import { DocumentType } from '@pelicargo/types';
import z from 'zod';

export const documentSchema = z.object({
  original_filename: z.string().optional(),
  type: z.nativeEnum(DocumentType),
  request_id: z.number().nullish(),
});
